export interface ICompanyMenuItem {
    id: string;
    code: string;
    name: string;
    logo: string;
    active: boolean;
}

export class CompanyMenuItem implements ICompanyMenuItem {
    id: string;
    code: string;
    name: string;
    logo: string;
    active: boolean;

    constructor();
    constructor(obj: ICompanyMenuItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.logo = obj && obj.logo || "";
        this.active = obj && obj.active || false;
    }
}